import type { FC, ReactNode } from 'react';

import { Box } from '@mui/material';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material';

interface CenteredLayoutProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Layout component that centers content with top margin.
 * Used for pages that need centered content presentation.
 */
export const CenteredLayout: FC<CenteredLayoutProps> = ({ children, sx }) => {
  const sxArray = normalizeSx(sx);

  return (
    <Box
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: '4vh'
        },
        ...sxArray
      ]}
    >
      {children}
    </Box>
  );
};
